// extracted by mini-css-extract-plugin
export default {"title":"SurveyQuestions_title__N7C76"};